import React from 'react';
import PropTypes from 'prop-types';
import { getHTag } from 'utils/get-tag';
import { useCategoryColor } from '@/hooks/useCategoryColor';
import s from './headline.module.scss';

function Headline(props) {
  const {
    h1,
    h3,
    h2,
    html,
    el,
    primary,
    secondary,
    purple,
    orange,
    pink,
    teal,
    green,
    title,
    center,
    right,
    smallCenter,
    bold,
    reg,
    white,
    underlined,
    category,
    linkto,
    ...other
  } = props;
  const { categoryColor } = useCategoryColor(category);
  const color = cl => (props[cl] ? s[cl] : '');
  const primaryClasses = primary ? s.primary : '';
  const secondaryClasses = secondary ? s.secondary : '';
  const titleClasses = title ? s.title : '';
  const underlinedClass = underlined ? s.underlined : '';
  const boldClasses = bold ? s.bold : '';
  const regClasses = reg ? s.reg : '';
  const fontClasses = boldClasses || regClasses || '';
  const whiteClass = white ? s.white : '';
  const colorClasses = primaryClasses || secondaryClasses || whiteClass;
  const titleColorClasses =
    color('purple') ||
    color('orange') ||
    color('green') ||
    color('pink') ||
    color('teal') ||
    '';
  const centerClass = center ? s.center : '';
  const rightClass = right ? s.right : '';
  const positionClasses = `${centerClass} ${rightClass} ${
    smallCenter ? s.smallCenter : ''
  } ${title && !secondaryClasses && titleColorClasses}`;
  const getElement = () => {
    if (h1) return 'h1';
    return h2 ? 'h2' : 'h3';
  };
  const elementTag = el || getElement();
  const defaultClasses = `${
    s[getElement()]
  } ${titleClasses} ${colorClasses} ${positionClasses} ${fontClasses} ${underlinedClass}`;
  const headlineProps = {
    ...other,
    className: `${defaultClasses} ${props.className || ''}`
  };
  const Tag = html ? getHTag(html).element || elementTag : elementTag;
  const innerHtml = (html && getHTag(html).body) || html;
  if (html) {
    return title ? (
      <div className={s.wrapper}>
        <Tag
          {...headlineProps}
          dangerouslySetInnerHTML={{ __html: `${innerHtml}` }}
        />
        <span className={s.line} />
      </div>
    ) : (
      <Tag
        {...headlineProps}
        dangerouslySetInnerHTML={{ __html: `${innerHtml}` }}
      />
    );
  }
  if (underlined) {
    return (
      <>
        <Tag {...headlineProps}>
          {props.children}
          <span
            className={`${s.line} ${categoryColor && s[categoryColor]}`}
          />
        </Tag>
      </>
    );
  }
  return title ? (
    <>
      <Tag {...headlineProps}>
        {props.children}
        <span className={s.line} />
      </Tag>
    </>
  ) : (
    <Tag {...headlineProps}>{props.children}</Tag>
  );
}

const validateProp = (props, name, component) => {
  if (!props.h1 && !props.h2 && !props.h3) {
    return new Error(
      `Please specify either h1, h2 or h3 prop in ${component}'.`
    );
  }
  if (props[name] && typeof props[name] !== 'boolean') {
    return new Error(`Prop ${name} in ${component} must be a boolean value.`);
  }
  return null;
};

Headline.propTypes = {
  h1: validateProp,
  h2: validateProp,
  h3: validateProp,
  el: PropTypes.string
};

export default Headline;
